import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'panel-header',
    templateUrl: './panel-header.component.html',
    styleUrls: ['./panel-header.component.scss']
})
export class PanelHeaderComponent implements OnInit {
    @Input()
    public stepTitle: string;

    @Input()
    public stepText: string;

    @Input()
    public stepDescription: string;

    @Input()
    public stepBackLabel: string;

    @Input()
    public stepBackRouterLink: any;

    @Input()
    public stepBackRouterLinkQueryParams: any;

    constructor() {}

    public ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/viega-common/components/collapsible-panel/panel-header/panel-header.component.ts